// src/pages/Awards.jsx
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { PublicAPI } from '../api/public';

const Page = styled.main`padding:22px 0;`;
const Container = styled.div`width:min(1400px,96vw); margin:0 auto; padding:0 18px; display:grid; gap:16px;`;
const Filters = styled.div`display:flex; gap:10px; flex-wrap:wrap; align-items:center;`;
const Grid = styled.div`
  display:grid; gap:14px; grid-template-columns: repeat(4, 1fr);
  @media (max-width:1100px){ grid-template-columns: repeat(3, 1fr); }
  @media (max-width:760px){ grid-template-columns: repeat(2, 1fr); }
  @media (max-width:520px){ grid-template-columns: 1fr; }
`;
const Card = styled.div`
  border:1px solid var(--bdr); border-radius:14px; background:var(--card); box-shadow:var(--shadow);
  overflow:hidden; display:grid; grid-template-rows: 140px 1fr;
  img{ width:100%; height:140px; object-fit:contain; background: #fafafa; }
  .body{ padding:10px 12px; }
  h4{ margin:0 0 6px; font-size:15px; }
  .meta{ font-size:12px; opacity:.75; display:flex; gap:8px; flex-wrap:wrap; }
`;
const Pager = styled.div`display:flex; gap:8px; align-items:center; justify-content:center; margin-top:8px;`;

export default function AwardsPage(){
  const { i18n } = useTranslation();

  const [items, setItems] = React.useState([]);
  const [page, setPage]   = React.useState(1);
  const [pages, setPages] = React.useState(1);
  const [loading, setLoading] = React.useState(false);

  // filters
  const [category, setCategory] = React.useState('');
  const [featuredOnly, setFeaturedOnly] = React.useState(false);
  const [yf, setYF] = React.useState('');
  const [yt, setYT] = React.useState('');

  const load = React.useCallback(async ()=>{
    setLoading(true);
    try{
      const res = await PublicAPI.awards({
        locale: i18n.language || 'ru',
        category: category || undefined,
        featured_only: featuredOnly || undefined,
        year_from: yf || undefined,
        year_to: yt || undefined,
        page,
        page_size: 24,
      });
      const arr = res?.items || res?.awards || [];
      setItems(arr);
      setPages(res?.pagination?.pages || 1);
    }catch(e){
      setItems([]); setPages(1);
    }finally{
      setLoading(false);
    }
  }, [i18n.language, category, featuredOnly, yf, yt, page]);

  React.useEffect(()=>{ load(); }, [load]);

  const applyFilters = () => { setPage(1); load(); };

  return (
    <Page>
      <Container>
        <h1 style={{margin:'0 0 4px'}}>Награды</h1>

        <Filters>
          <input placeholder="Категория (award|certificate|recognition)" value={category} onChange={e=>setCategory(e.target.value)} />
          <label style={{display:'inline-flex', alignItems:'center', gap:6}}>
            <input type="checkbox" checked={featuredOnly} onChange={e=>setFeaturedOnly(e.target.checked)} />
            Только избранные
          </label>
          <input type="number" placeholder="Год от" value={yf} onChange={e=>setYF(e.target.value)} style={{width:110}} />
          <input type="number" placeholder="Год до" value={yt} onChange={e=>setYT(e.target.value)} style={{width:110}} />
          <button className="btn" onClick={applyFilters} disabled={loading}>
            {loading ? 'Загрузка…' : 'Применить'}
          </button>
        </Filters>

        <Grid>
          {items.map(a=>(
            <Link key={a.id} to={`/awards/${a.id}`} style={{ textDecoration:'none', color:'inherit' }}>
              <Card>
                {(a.image_thumb || a.image)
                  ? <img src={a.image_thumb || a.image} alt={a.title} loading="lazy" />
                  : <div style={{display:'grid', placeItems:'center', fontWeight:700, opacity:.5}}>No image</div>}
                <div className="body">
                  <h4 title={a.title}>{a.title}</h4>
                  <div className="meta">
                    {a.organization && <span>{a.organization}</span>}
                    {a.category && <span>#{a.category}</span>}
                    {a.year && <span>{a.year}</span>}
                  </div>
                </div>
              </Card>
            </Link>
          ))}
          {!items.length && !loading && <div style={{opacity:.7}}>Нет данных</div>}
        </Grid>

        <Pager>
          <button className="btn" onClick={()=>setPage(p=>Math.max(1, p-1))} disabled={page<=1 || loading}>← Назад</button>
          <span style={{opacity:.7}}>Стр. {page} / {pages}</span>
          <button className="btn" onClick={()=>setPage(p=>Math.min(pages, p+1))} disabled={page>=pages || loading}>Вперёд →</button>
        </Pager>
      </Container>
    </Page>
  );
}
